import React from 'react';
import { SelectionArea, Layer } from '../types';

interface SelectionOverlayProps {
  layers: Layer[];
  selectedClipMaskId: string | null;
  handleClipMaskClick: (layerId: string, e: React.MouseEvent) => void;
  renderResizeHandles: (
    layerId: string,
    mask: SelectionArea
  ) => React.ReactNode;
  isSelectionMode: boolean;
  isDrawing: boolean;
  drawSelection: (
    startPoint: { x: number; y: number },
    currentPoint: { x: number; y: number }
  ) => React.ReactNode;
  startPoint: { x: number; y: number };
  currentPoint: { x: number; y: number };
}

export const SelectionOverlay: React.FC<SelectionOverlayProps> = ({
  layers,
  selectedClipMaskId,
  handleClipMaskClick,
  renderResizeHandles,
  isSelectionMode,
  isDrawing,
  drawSelection,
  startPoint,
  currentPoint,
}) => {
  return (
    <g>
      {/* クリッピングマスクの範囲を表示（選択された時のみ） */}
      {layers.map(
        (layer) =>
          layer.clipMask &&
          selectedClipMaskId === layer.id && (
            <g key={`clip-mask-${layer.id}`}>
              <rect
                data-mask-bounds="true"
                data-layer-id={layer.id}
                x={layer.clipMask.x}
                y={layer.clipMask.y}
                width={layer.clipMask.width}
                height={layer.clipMask.height}
                fillOpacity="0"
                stroke="gray"
                strokeWidth="2"
                strokeDasharray="5,5"
                style={{ cursor: 'move' }}
                onClick={(e) => handleClipMaskClick(layer.id, e)}
              />
              {renderResizeHandles(layer.id, layer.clipMask)}
            </g>
          )
      )}

      {/* 選択範囲の描画 */}
      {isSelectionMode && isDrawing && (
        <g>{drawSelection(startPoint, currentPoint)}</g>
      )}
    </g>
  );
};
